import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  useTheme, 
  IconButton, 
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery
} from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const PublicNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/events-landing', label: 'Events' },
    { path: '/team', label: 'Team' },
    { path: '/sponsors', label: 'Sponsors' }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const renderNavItems = () => (
    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 4 }}>
      {navItems.map((item) => (
        <Typography
          key={item.path}
          onClick={() => handleNavigation(item.path)}
          sx={{
            cursor: 'pointer',
            fontWeight: 500,
            position: 'relative',
            color: 'inherit',
            '&:after': {
              content: '""',
              position: 'absolute',
              bottom: -4,
              left: 0,
              width: '100%',
              height: 2,
              backgroundColor: 'error.main',
              opacity: isActive(item.path) ? 1 : 0,
              transition: 'opacity 0.2s ease'
            },
            '&:hover': {
              '&:after': {
                opacity: 0.7
              }
            }
          }}
        >
          {item.label}
        </Typography>
      ))}
    </Box>
  );

  const renderMobileDrawer = () => (
    <Drawer
      anchor="right"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true // Better mobile performance
      }}
      PaperProps={{
        sx: {
          backgroundColor: 'black',
          color: 'white',
          width: 240,
          '& .MuiListItem-root': {
            py: 2
          }
        }
      }}
    >
      <List sx={{ mt: 8 }}>
        {navItems.map((item) => (
          <ListItem 
            key={item.path}
            onClick={() => handleNavigation(item.path)}
            sx={{
              cursor: 'pointer',
              backgroundColor: isActive(item.path) ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.12)'
              }
            }}
          >
            <ListItemText 
              primary={item.label}
              sx={{
                '& .MuiTypography-root': {
                  fontWeight: isActive(item.path) ? 600 : 400
                }
              }}
            />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );

  return (
    <Box 
      sx={{ 
        position: 'absolute', 
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        p: { xs: 3, md: 4 },
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}
    >
      {/* Logo and Brand */}
      <Box 
        sx={{ 
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Box 
          component="img"
          src="/logo192.png"
          alt="CAMATS Logo"
          sx={{ 
            height: { xs: 40, md: 50 },
            mr: 2,
            display: 'inline-block',
            verticalAlign: 'middle',
            cursor: 'pointer'
          }}
          onClick={() => handleNavigation('/events-landing')}
        />
        <Typography 
          variant="text" 
          color="inherit" 
          onClick={() => handleNavigation('/workshop')}
          sx={{ 
            fontWeight: 600,
            fontSize: { xs: '0.9rem', md: '1.1rem' },
            textTransform: 'none',
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.8
            }
          }}
        >
          CAMATS TEAM RACING
        </Typography>
      </Box>

      {/* Desktop Navigation */}
      {renderNavItems()}

      {/* Mobile Menu Button */}
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleDrawerToggle}
        sx={{ 
          display: { md: 'none' },
          ml: 2
        }}
      >
        <MenuIcon />
      </IconButton>

      {/* Mobile Drawer */}
      {renderMobileDrawer()}
    </Box>
  );
};

export default PublicNavbar; 